class ThemeStyleSheet extends HTMLElement {
  // Tracks all registered stylesheets by name
  static registeredStyles = new Map()

  connectedCallback() {
    this.name = this.getAttribute('name')
    this.removeDuplicate = this.getAttribute('remove-duplicate') === 'true'
    this.load = this.getAttribute('load')
    this.isRemovedDueToDuplicate = false

    if (!this.name) {
      console.warn('ThemeStyleSheet: Missing required "name" attribute')
      return
    }

    if (!ThemeStyleSheet.registeredStyles.has(this.name)) {
      ThemeStyleSheet.registeredStyles.set(this.name, new Set())
    }

    ThemeStyleSheet.registeredStyles.get(this.name).add(this)
    this.queueCleanup()
  }

  disconnectedCallback() {
    if (this.isRemovedDueToDuplicate) {
      return
    }

    const stylesForName = ThemeStyleSheet.registeredStyles.get(this.name)
    if (stylesForName) {
      stylesForName.delete(this)

      if (stylesForName.size === 0) {
        ThemeStyleSheet.registeredStyles.delete(this.name)
      }
    }
  }

  // Handles duplicate stylesheets by keeping only one instance
  queueCleanup() {
    setTimeout(() => {
      const stylesForName = ThemeStyleSheet.registeredStyles.get(this.name)

      if (!stylesForName?.size || stylesForName.size <= 1) {
        return
      }

      // Prioritize inline styles, otherwise use the first one
      const styleToKeep =
        Array.from(stylesForName).find((style) => style.load === 'inline') || Array.from(stylesForName)[0]

      stylesForName.forEach((style) => {
        if (style !== styleToKeep && style.removeDuplicate) {
          stylesForName.delete(style)
          style.isRemovedDueToDuplicate = true
          style.remove()
        }
      })
    }, 0)
  }
}

customElements.define('style-sheet', ThemeStyleSheet)

/* Grayish mobile menu: make the complete parent row toggle its submenu. */
(function () {
  if (window.GrayishMobileNavRowToggleV2) return;
  window.GrayishMobileNavRowToggleV2 = true;

  var mobileQuery = window.matchMedia('(max-width: 719px)');

  function toggleSubmenuFromParentLink(event) {
    if (!mobileQuery.matches) return;

    var parentLink = event.target.closest(
      '.site-mobile-nav [data-navmenu-parent] > .navmenu-link-parent'
    );

    if (!parentLink) return;

    var parentItem = parentLink.parentElement;
    var trigger = null;

    for (var i = 0; i < parentItem.children.length; i += 1) {
      if (parentItem.children[i].matches('[data-navmenu-trigger]')) {
        trigger = parentItem.children[i];
        break;
      }
    }

    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.click();
  }

  document.addEventListener('click', toggleSubmenuFromParentLink, true);
})();

